module.exports = __webpack_public_path__ + "img/deco-2.e6197b67.svg";